import OrderProduct from 'components/OrderProduct';

const PageOrderFurniture = () => {
    return (
        <div className="container mx-auto p-6">
            <OrderProduct category_id={1} description='If you require other furniture not listed in this catalogue, please contact us and we will be happy to advise'/>
        </div>
    );
};

export default PageOrderFurniture;
